import Controller from '@ember/controller';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { service } from '@ember/service';

export default class KineticJobsInQueueController extends Controller {
  @service router;

  queryParams = ['searchTerm', 'beginDate', 'endDate'];

  @tracked searchTerm;
  @tracked beginDate;
  @tracked endDate;

  @action
  onOperationSelected(assemblyOperation) {
    this.router.transitionTo('kineticOperations.operation', assemblyOperation.operation);
  }

  @action
  onParamChange(key, value) {
    this[key] = value;
  }
}
